module.exports = __webpack_public_path__ + "img/scores.667795c6.svg";